import { useEffect, useState } from 'react';
import type { Module } from '@/types/modules';

/**
 * Gmail sync-in-progress tracking: keep the options menu open while sync is
 * running, show a spinner on the Sync item, and close the menu when sync
 * completes. Driven by events dispatched from EmailPanel.handleSyncNow.
 */
export function useEmailSyncOverlay(selectedChatPaneModule: Module | null): {
  moduleMenuCloseSignal: number;
  isChatPaneEmailSyncing: boolean;
} {
  const [emailSyncingModuleId, setEmailSyncingModuleId] = useState<string | null>(null);
  const [moduleMenuCloseSignal, setModuleMenuCloseSignal] = useState(0);

  useEffect(() => {
    const onStart = (e: Event) => {
      const id = (e as CustomEvent).detail?.moduleId as string | undefined;
      if (id) setEmailSyncingModuleId(id);
    };
    const onEnd = (e: Event) => {
      const id = (e as CustomEvent).detail?.moduleId as string | undefined;
      setEmailSyncingModuleId(prev => (id && prev !== id) ? prev : null);
      setModuleMenuCloseSignal(s => s + 1);
    };
    window.addEventListener('xavior:email-sync-started', onStart);
    window.addEventListener('xavior:email-sync-completed', onEnd);
    return () => {
      window.removeEventListener('xavior:email-sync-started', onStart);
      window.removeEventListener('xavior:email-sync-completed', onEnd);
    };
  }, []);
  const isChatPaneEmailSyncing = Boolean(
    selectedChatPaneModule && emailSyncingModuleId === selectedChatPaneModule.id,
  );

  return { moduleMenuCloseSignal, isChatPaneEmailSyncing };
}
